import { useRouteError } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

export function RouteErrorPage() {
  const error = useRouteError();

  return (
    <Box sx={{ textAlign: 'center', p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {error?.statusText || error?.message || "An unexpected error occurred."}
      </Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Try again
      </Button>
    </Box>
  );
}
